import React from 'react';
import {
    Checkbox, // Reusing the new styled Checkbox
    StyledTextarea, // Renamed from ItemTitle, now using new styles
    DeleteButton, // Reusing the new styled DeleteButton
    DragHandle, // Reusing the styled DragHandle for the wrapper div
    ConvertToCardButton, // Preserved
    // ItemContainer is handled by ChecklistItem.js, StyledChecklistItemContainer is its new name
    // Assuming a similar button style for the new button, or we might need a new styled component.
    // For now, re-using ConvertToCardButton styles and adapting if necessary.
} from '../../styles/ChecklistItem.styles';
// import DragHandleIcon from '../icons/DragHandleIcon'; // Will use inline SVG
import { ConvertIcon } from '../icons/ConvertIcon';
import PlusIcon from '../icons/PlusIcon'; // Import PlusIcon for the new button

const ChecklistItemContent = ({
    textareaRef,
    item,
    onToggle,
    onUpdate, // This will be passed to StyledTextarea's onChange
    onDelete,
    onBlur,
    onKeyDown,
    dragHandleProps, // These props will be spread onto the DragHandle styled component
    onConvert,
    handleCreateSubtaskFromChecklistItem // Receive new handler
}) => {
    return (
        <>
            {/* Drag handle SVG from ProjectChecklistModal, wrapped by styled DragHandle */}
            <DragHandle {...dragHandleProps}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 3C4.1 3 5 3.9 5 5C5 6.1 4.1 7 3 7C1.9 7 1 6.1 1 5C1 3.9 1.9 3 3 3ZM10 3C11.1 3 12 3.9 12 5C12 6.1 11.1 7 10 7C8.9 7 8 6.1 8 5C8 3.9 8.9 3 10 3ZM3 10C4.1 10 5 10.9 5 12C5 13.1 4.1 14 3 14C1.9 14 1 13.1 1 12C1 10.9 1.9 10 3 10ZM10 10C11.1 10 12 10.9 12 12C12 13.1 11.1 14 10 14C8.9 14 8 13.1 8 12C8 10.9 8.9 10 10 10ZM3 17C4.1 17 5 17.9 5 19C5 20.1 4.1 21 3 21C1.9 21 1 20.1 1 19C1 17.9 1.9 17 3 17ZM10 17C11.1 17 12 17.9 12 19C12 20.1 11.1 21 10 21C8.9 21 8 20.1 8 19C8 17.9 8.9 17 10 17Z" />
                    {/* SVG fill is handled by CSS in DragHandle styled component */}
                </svg>
            </DragHandle>
            <Checkbox
                type="checkbox"
                checked={item.completed}
                onChange={onToggle} // onToggle likely calls a function that eventually calls toggleChecklistItem
            />
            <StyledTextarea
                ref={textareaRef}
                value={item.text}
                onChange={onUpdate} // onUpdate is already expected to be (e) => handleTextareaChange(e) from ChecklistItem.js
                onBlur={onBlur}
                onKeyDown={onKeyDown}
                checked={item.completed}
                placeholder="Add an item..." // Changed placeholder to match ProjectChecklistModal's "Add item..."
                // autoFocus logic might be needed if new items should focus, but that's handled by NewItemInput in CardChecklists.js
                // The auto-height adjustment is handled by ChecklistItem.js useEffect and handleTextareaChange
            />
            {/* ConvertToCardButton is specific to CardModal's checklists, kept as is */}
            {!item.completed && onConvert && (
                <ConvertToCardButton
                    onClick={onConvert}
                    title="Convert to card"
                >
                    <ConvertIcon />
                </ConvertToCardButton>
            )}
            {/* New button to create subtask */}
            {!item.completed && handleCreateSubtaskFromChecklistItem && (
                <ConvertToCardButton // Re-using style, can be renamed or restyled if needed
                    onClick={() => handleCreateSubtaskFromChecklistItem(item.text)}
                    title="Create subtask from item"
                    // Add some margin if both buttons are present
                    style={{ marginLeft: onConvert ? '4px' : '0' }}
                >
                    <PlusIcon /> {/* Using PlusIcon */}
                </ConvertToCardButton>
            )}
            <DeleteButton
                onClick={onDelete} // onDelete likely calls handleDeleteChecklistItem
                title="Delete item"
                type="button" // Good practice for buttons not submitting forms
            >
                ×
            </DeleteButton>
        </>
    );
};

export default ChecklistItemContent;